import React from 'react';
import { articles1, articles2 } from './data';
import './Styles/Articles.scss';
import {List} from './Container';
const Articles = ()=>{
    return(
        <div className="articles-help">
            <h1>Featured articles</h1>
            <div className="articles">
                <div className="firstdiv">

                <List  list={articles1}/>
                </div>
                <List  list={articles2}/>
            </div>
        </div>
    )
};
export default Articles ;